// Currency catalog — extend freely. Symbols feed the formatter when Intl
// can't resolve them (rare). `decimals` lets us deviate from currency defaults
// (e.g. JPY uses 0 decimals).
export const CURRENCIES = [
    { code: "GBP", symbol: "£",  name: "British Pound" },
    { code: "EUR", symbol: "€",  name: "Euro" },
    { code: "USD", symbol: "$",  name: "US Dollar" },
    { code: "CAD", symbol: "$",  name: "Canadian Dollar" },
    { code: "AUD", symbol: "$",  name: "Australian Dollar" },
    { code: "NZD", symbol: "$",  name: "New Zealand Dollar" },
    { code: "CHF", symbol: "Fr", name: "Swiss Franc" },
    { code: "SEK", symbol: "kr", name: "Swedish Krona" },
    { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
    { code: "DKK", symbol: "kr", name: "Danish Krone" },
    { code: "PLN", symbol: "zł", name: "Polish Złoty" },
    { code: "CZK", symbol: "Kč", name: "Czech Koruna" },
    { code: "HUF", symbol: "Ft", name: "Hungarian Forint",   decimals: 0 },
    { code: "RON", symbol: "lei",name: "Romanian Leu" },
    { code: "JPY", symbol: "¥",  name: "Japanese Yen",       decimals: 0 },
    { code: "CNY", symbol: "¥",  name: "Chinese Yuan" },
    { code: "HKD", symbol: "$",  name: "Hong Kong Dollar" },
    { code: "SGD", symbol: "$",  name: "Singapore Dollar" },
    { code: "INR", symbol: "₹",  name: "Indian Rupee" },
    { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
    { code: "SAR", symbol: "﷼",  name: "Saudi Riyal" },
    { code: "ZAR", symbol: "R",  name: "South African Rand" },
    { code: "MXN", symbol: "$",  name: "Mexican Peso" },
    { code: "BRL", symbol: "R$", name: "Brazilian Real" },
    { code: "TRY", symbol: "₺",  name: "Turkish Lira" },
];

export const findCurrency = (code) => CURRENCIES.find(c => c.code === code) || CURRENCIES[0];

// Per-currency Intl locale mapping so amounts render in the format native to
// each currency (e.g. USD → "$1,234.56" via en-US, EUR → "1.234,56 €" via
// de-DE / es-ES fallback, JPY → "¥1,235" via ja-JP). If a currency isn't
// mapped, fmtCurrency falls back to the user's regional locale.
// Values are NOT converted — this only affects symbol placement and digit
// grouping.
export const CURRENCY_LOCALES = {
    GBP: "en-GB",
    USD: "en-US",
    CAD: "en-CA",
    AUD: "en-AU",
    NZD: "en-NZ",
    JPY: "ja-JP",
    CNY: "zh-CN",
    HKD: "en-HK",
    SGD: "en-SG",
    INR: "en-IN",
    CHF: "de-CH",
    SEK: "sv-SE",
    NOK: "nb-NO",
    DKK: "da-DK",
    PLN: "pl-PL",
    CZK: "cs-CZ",
    HUF: "hu-HU",
    RON: "ro-RO",
    AED: "ar-AE",
    SAR: "ar-SA",
    ZAR: "en-ZA",
    MXN: "es-MX",
    BRL: "pt-BR",
    TRY: "tr-TR",
    // EUR intentionally omitted — resolved dynamically by fmtCurrency so the
    // user's own language wins (fr-FR / de-DE / es-ES / it-IT / …), falling
    // back to es-ES for consistent "1.234,56 €" formatting when the user's
    // language isn't a eurozone language.
};

// Eurozone language → locale mapping. Anything not in here (including
// English) falls back to es-ES so EUR always renders as continental
// "1.234,56 €" rather than the anglo "€1,234.56". This matches the spec
// requirement that EUR should never look like the pre-fix bug.
const EUR_LANG_LOCALES = {
    de: "de-DE", fr: "fr-FR", es: "es-ES", it: "it-IT", pt: "pt-PT",
    nl: "nl-NL", el: "el-GR", fi: "fi-FI", pl: "pl-PL", cs: "cs-CZ",
    ro: "ro-RO", hu: "hu-HU", sv: "sv-SE", da: "da-DK", no: "nb-NO",
};

export function currencyLocale(currencyCode, userLanguage) {
    if (currencyCode === "EUR") {
        const short = String(userLanguage || "").split("-")[0].toLowerCase();
        return EUR_LANG_LOCALES[short] || "es-ES";
    }
    return CURRENCY_LOCALES[currencyCode] || null;
}
